import { render, staticRenderFns } from "./PasswordResetRequestForm.vue?vue&type=template&id=f7a9b820&scoped=true&"
import script from "./PasswordResetRequestForm.vue?vue&type=script&lang=js&"
export * from "./PasswordResetRequestForm.vue?vue&type=script&lang=js&"
import style0 from "./PasswordResetRequestForm.vue?vue&type=style&index=0&id=f7a9b820&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f7a9b820",
  null
  
)

export default component.exports